import { SET_SEARCH_CATEGORY, 
        SET_SEARCH_PARAMS, 
        APPEND_SEARCH_RESULTS, 
        CLEAR_SEARCH_DATA, 
        SET_SEARCH_FINISHED,
        SET_SEARCH_ISREPOSITORY } from '../actions/actionTypes';

const initialState = {
    category: 'title',
    results: [],
    offset: 0,
    hasMoreResults: true,
    item: {},
    isRepository: false,
  };
  
export const searchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SEARCH_PARAMS:
            return {
                ...state,
                ...action.payload,
            };
        case SET_SEARCH_CATEGORY:
            return {
                ...state,
                category: action.payload
            };
        case SET_SEARCH_ISREPOSITORY:
            return {
                ...state,
                isRepository: action.payload
            };
        case SET_SEARCH_FINISHED:
            return {
                ...state,
                hasMoreResults: false,
            };
        case APPEND_SEARCH_RESULTS:
            return {
                ...state,
                results: state.results.concat(action.payload),
                offset: state.offset + action.payload.length,
            };
        case CLEAR_SEARCH_DATA:
            return {
                ...initialState,
                category: state.category,
                library: state.library,
                materialType: state.materialType,
            };
        default:
            return state;
    }
};